export enum BillingInterval {
	OneOff = "one_off",
	Week = "week",
	Month = "month",
	Quarter = "quarter",
	SemiAnnual = "semi_annual",
	Year = "year",
}
